/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {
  PRINT_SCALES,
  TIMEOUT,
}                                   from 'g3w-constants';
import Component                    from 'g3w-component';
import ApplicationState             from 'store/application';
import GUI                          from 'services/gui';
import { getScaleFromResolution }   from 'utils/getScaleFromResolution';
import { getResolutionFromScale }   from 'utils/getResolutionFromScale';
import { saveBlob }                 from 'utils/saveBlob';
import { printAtlas }               from 'utils/printAtlas';
import { promisify }                from 'utils/promisify';
import { getCatalogLayerById }      from 'utils/getCatalogLayerById';

import resizeMixin                  from 'mixins/resize';

import vueComp                      from 'components/PrintPage.vue';
import { t }                        from 'g3w-i18n';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'print',

  mixins: [resizeMixin],

  data() {
    this.init();
    return {
      state: this.state || {},
      disabled: false,
      /** @since 3.10.0 */
      atlas_values:   [],
    };
  },

  computed: {

    /**
     * @returns { boolean } whether current print has maps (only alphanumerical data)
     * 
     * @since 3.9.4
     */
    has_maps() {
      return (this.state.maps || []).length > 0;
    },

    //in the case of current template is atlas and has field_name
    has_autocomplete() {
      return !!(this.state.atlas && this.state.atlas.field_name);
    },

    /** @since 3.10.0  */
    lang() {
      return ApplicationState.language;
    },

  },

  methods: {

    init() {
      this._init        = undefined !== this._init ? this._init: false;
      this._moveKey     = this._moveKey || null;
      this._page        = this._page || null;
      this._resolutions = this._resolutions || {};

      const print   = ApplicationState.project.getPrint() || [];
      const visible = print.length > 0;

      const PRINT_FORMATS = [
        { value: 'png', label: 'PNG' },
        { value: 'jpg', label: 'JPG' },
        { value: 'svg', label: 'SVG' },
        { value: 'pdf', label: 'PDF' },
        { value: 'geopdf', label: 'GEOPDF' },
      ];

      this.state = Object.assign(this.state || {}, {
        visible,
        print,
        loading:      false,
        downloading:  false,
        url:          null,
        layers:       true,
        maps:         visible ? print[0].maps   : undefined,
        labels:       visible ? print[0].labels : undefined,
        template:     visible ? print[0].name   : undefined,
        atlas:        visible ? print[0].atlas  : undefined,
        rotation:     visible ? 0               : undefined,
        inner:        [0, 0, 0, 0],
        scales:       [], // initial set empty
        scale:        visible ? null            : undefined,
        dpis:         [150, 300],
        dpi:          150,
        formats:      PRINT_FORMATS,
        format:       PRINT_FORMATS[0].value,
      });

      /**@since v3.10 Store map extent for print in case of already open print page*/
      this.print_extent = null;

    },

    resize() {
      if (this.select2 && !ApplicationState.ismobile) {
        this.select2.select2('close');
      }
    },

    async changeTemplate() {
      if (!this.state.template) { return; }

      await this.$nextTick();

      // destroy select2 dom element and remove all events
      if (this.select2) {
        this.select2.select2('destroy');
        this.select2.off();
        this.select2 = null;
      }

      this.disabled = false;

      const has_previous = this.state.atlas || 0 === this.state.maps.length;
      const print        = this.state.print.find(p => p.name === this.state.template)

      Object.assign(this.state, {
        maps:        print.maps,
        atlas:       print.atlas,
        labels:      print.labels,
      });

      this.atlas_values = [];

      if (this.state.atlas) {
        this._clearPrint();
        this.initSelect2Field();
      } else if (has_previous) {
        this.showPrintArea(true);
      } else {
        this._setPrintArea();
      }

      await this.$nextTick();
    },

    /**
     * On scale change set print area
     */
    changeScale() {

      try {
        //check if create new tag value with ':' 1:2300
        if (this.state.scale.includes(':')) {
          //get value
          const scale = Number(this.state.scale.split(':')[1].trim());
          //set options last tag created by user
          this.$refs.scales.children[this.$refs.scales.children.length -1].value = scale;
          //set scale
          this.state.scale = scale;

        }
      } catch(e) {
        console.warn(e);
        this.state.scale = this.state.scales[0].value;
      }

      //check if a current scale is a number or has a value more than maximum scale permission
      if (Number.isNaN(Number(this.state.scale)) || (this.state.scale > this.state.scales[0].value)) {
        this.state.scale = this.state.scales[0].value;
      }

      //In case of scale negative or less than minimum scale permission
      if (this.state.scale < 0) {
        this.state.scale = this.state.scales[this.state.scales.length - 1].value;
      }

      //set value
      $(this.$refs.scales).val(this.state.scale).trigger('change');

      if (this.state.scale) { this._setPrintArea(); }


    },

    /**
     * @since 3.10.0
     */
    changeDpi() {
      //check dpi if si a NaN
      if (Number.isNaN(Number(this.state.dpi))) {
        this.state.dpi = this.state.dpis[0];
        //set value
        $(this.$refs.dpi).val(this.state.dpi).trigger('change');
      }
    },

    /**
     * On change rotation, rotate print area
     */
    changeRotation() {
      this.state.rotation = this.state.rotation >= 0 ? Math.min(this.state.rotation || 0, 360) : Math.max(this.state.rotation || 0, -360);
      GUI.getService('map').setInnerGreyCoverBBox({ rotation: this.state.rotation });
    },

    /**
     * @since 3.11.0
     */
    isAxisOrientationInverted() {
      return 'neu' === GUI.getService('map').getProjection().getAxisOrientation();
    },

    /**
     * @param extent
     *
     * @returns { string }
     */
    getOverviewExtent(extent={}) {
      const { xmin, xmax, ymin, ymax } = extent;
      return (this.isAxisOrientationInverted() ? [ymin, xmin, ymax, xmax] : [xmin, ymin, xmax, ymax]).join();
    },

    /**
     * @returns { string }
     */
    getPrintExtent() {
      const map          = GUI.getService('map').viewer.map;
      // Need to check in case di an open print page
      try {
        const [xmin, ymin] = map.getCoordinateFromPixel([this.state.inner[0], this.state.inner[1]]);
        const [xmax, ymax] = map.getCoordinateFromPixel([this.state.inner[2], this.state.inner[3]]);
        this.print_extent  = (this.isAxisOrientationInverted() ? [ymin, xmin, ymax, xmax] : [xmin, ymin, xmax, ymax]).join();
      }
      catch(e) {
         //in case of already open content print page
        console.warn(e);
      }

      return this.print_extent;
    },

    /*
    http://localhost/fcgi-bin/qgis_mapserver/qgis_mapserv.fcgi
      ?MAP=/home/marco/geodaten/projekte/composertest.qgs
      &SERVICE=WMS&VERSION=1.3.0
      &REQUEST=GetPrint
      &TEMPLATE=Composer 1
      &map0:extent=693457.466131,227122.338236,700476.845177,230609.807051
      &BBOX=693457.466131,227122.338236,700476.845177,230609.807051
      &CRS=EPSG:21781
      &WIDTH=1467
      &HEIGHT=729
      &LAYERS=layer0,layer1
      &STYLES=,
      &FORMAT=pdf
      &DPI=300
      &TRANSPARENT=true

    In detail, the following parameters can be used to set properties for composer maps:

    <mapname>:EXTENT=<xmin,ymin,xmax, ymax> //mandatory
    <mapname>:ROTATION=<double> //optional, defaults to 0
    <mapname>:SCALE=<double> //optional. Forces scale denominator as server and client may have different scale calculations
    <mapname>:LAYERS=<comma separated list with layer names> //optional. Defaults to all layer in the WMS request
    <mapname>:STYLES=<comma separated list with style names> //optional
    <mapname>:GRID_INTERVAL_X=<double> //set the grid interval in x-direction for composer grids
    <mapname>:GRID_INTERVAL_Y=<double> //set the grid interval in x-direction for composer grids
    */
    /**
     * @returns { Promise<unknown> }
     */
    async print() {
      const has_atlas = !!this.state.atlas;
      let err;
      let response;

      this.state.loading = true;

      try {

        // disable sidebar
        GUI.disableSideBar(true);

        // close print page if already open
        if (this._page) {
          await promisify(GUI.closeContent());
        }

        // ATLAS PRINT
        if (has_atlas) {
          ApplicationState.download = true;

          const { url } = await printAtlas({
            template: this.state.template,
            field:    this.state.atlas.field_name || '$id',
            values:   this.atlas_values,
            download: true
          });

          const response = url && await fetch(url);

          if (!response?.ok) {
            throw (await response.json()).message;
          }

          saveBlob(await response.blob(), this.state.template);
        }

        // SIMPLE PRINT
        if (!has_atlas) {
          this.state.url       = null;
          this.state.layers    = true;

          this._page = new Component({ service: { state: this.state }, vueComponentObject: vueComp });

          // show print page with loading state
          GUI.setContent({
            content: this._page,
            title:   'print',
            perc:    100
          });

          const has_theme = this.state.maps.some(m => undefined !== m.preset_theme);
          const store     = ApplicationState.project.getLayersStore();
          const layers    = store.getLayers({ PRINTABLE: { scale: this.state.scale }, SERVERTYPE: 'QGIS' }).reverse(); // reverse order is important
          const LAYERS    = (layers || []).map(l => l.getPrintLayerName()).join();
          const url       = store.getWmsUrl();
          const params    = layers.length && new URLSearchParams(await GUI.getPrintParams({
            SERVICE:       'WMS',
            VERSION:       '1.3.0',
            REQUEST:       'GetPrint',
            TEMPLATE:       this.state.template,
            DPI:            this.state.dpi,
            STYLES:         layers.map(l => l.getStyle()).join(','),
            ...(has_theme ? {} : { LAYERS }), // in the case of a map that has preset_theme, no LAYERS need tyo pass as parameter.
            FORMAT:         ({ png: 'png', pdf: 'application/pdf', geopdf: 'application/pdf' })[this.state.format] || this.state.format,
            ...('geopdf' === this.state.format ? { FORMAT_OPTIONS: 'WRITE_GEO_PDF:TRUE'} : {}), //@since 3.10.0
            CRS:            store.getProjection().getCode(),
            filtertoken:    ApplicationState.tokens.filtertoken,
            ...this.state.maps.map(m => ({
              name:         m.name,
              preset_theme: m.preset_theme,
              scale:        m.overview ? m.scale : this.state.scale,
              extent:       m.overview ? this.getOverviewExtent(m.extent) : this.getPrintExtent()
            })).reduce((params, map) => Object.assign(params, {
              [`${map.name}:SCALE`]:    map.scale,
              [`${map.name}:EXTENT`]:   map.extent,
              [`${map.name}:ROTATION`]: this.state.rotation,
              //need to specify LAYERS from mapX in case of maps has at least one preset theme set, otherwise get layers from LAYERS param
              ...(has_theme && undefined === map.preset_theme ? { [`${map.name}:LAYERS`]: LAYERS } : {})
            }), {}),
            ...(this.state.labels || []).reduce((params, label) => Object.assign(params, { [label.id]: label.text }), {})
          })).toString();

      
          response = await (fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body:  params,
          }));
          
          if (200 !== response.status) {
            throw new Error(response.statusText);
          }

          this.state.url       = URL.createObjectURL(await response.blob());
          this.state.layers    = !!response.ok;
          //after component mount
          this._page.getInternalComponent().$on('hook:mounted', () => this.state.loading = false);
          // set print area after closing content
          this._page.unmount = () => {
            GUI.getService('map').viewer.map.once('postrender', this._setPrintArea.bind(this));
            const promise     = Component.prototype.unmount.call(this._page);
            this._page        = null;
            return promise;
          };
        }

      } catch(e) {
        if (response && !response.ok && 500 === response.status) {
          err = 500 === response.status ? 'Internal Server Error' : 'Request Failed';
        } else {
          err = e;
        }
        this.state.loading = false;
        // enable sidebar
        GUI.disableSideBar(false);
        console.warn(e);
      }

      this.state.loading = false;

      ApplicationState.download = false;

      // in case of no layers
      if (has_atlas || !this.state.layers) {
        GUI.disableSideBar(false);
      }

      if (err) {
        console.warn(err);
        GUI.notify.error(err || t("info.server_error"));
        GUI.closeContent();
      }

    },

    /**
     * @param { boolean } show
     */
    showPrintArea(show) {
      // close content if open
      const reset = !show;
      if (reset && this.select2)           { this.select2.val(null).trigger('change'); }
      if (reset)                           { this.atlas_values = []; this.print_extent = null; }
      // @since 3.11.0 In case of no print set, exit
      if (0 === this.state.print.length)   { return; }
      GUI
        .closeContent()
        .then(component => {
          setTimeout(() => {
            const map      = component.getService();
            map.getMap().once('postrender', () => {
              if (!show) {
                return this._clearPrint();
              }
              this._moveKey = map.viewer.map.on('moveend', this._setPrintArea.bind(this));
              this._initPrintConfig();
              // show print area if is not atlas template and have maps
              if (undefined === this.state.atlas && this._setPrintArea()) {
                map.startDrawGreyCover();
              }
            });
            map.getMap().renderSync();
          })
        })
    },

    /**
     * Calculate internal print extent
     * @returns { Boolean }
     */
    _setPrintArea() {
      // No maps set. Only attributes label
      if (!this.has_maps) {
        this._clearPrint();
        return false;
      }
      const map        = GUI.getService('map').viewer.map;
      const size       = map.getSize();
      const resolution = map.getView().getResolution();
      const { h, w }   = this.state.maps.find(m => !m.overview);
      const res        = resolution * ('m' === GUI.getService('map').getMapUnits() ? 1  : ol.proj.Units.METERS_PER_UNIT.degrees); // resolution in meters
      const w2         = (((w / 1000.0) * parseFloat(this.state.scale)) / res) / 2;
      const h2         = (((h / 1000.0) * parseFloat(this.state.scale)) / res) / 2;
      const [x, y]     = [ (size[0]) / 2, (size[1]) / 2 ]; // current map center: [x, y] (in pixel)
      this.state.inner = [x - w2, y + h2, x + w2, y - h2]; // inner bbox: [xmin, ymax, xmax, ymin] (in pixel)
      GUI.getService('map').setInnerGreyCoverBBox({
        type:     'pixel',
        inner:    this.state.inner,
        rotation: this.state.rotation
      });
      return true;
    },

    _clearPrint() {
      ol.Observable.unByKey(this._moveKey);
      this._moveKey = null;
      GUI.getService('map').stopDrawGreyCover();
    },

    /**
     * Set all scales based on max resolution
     *
     * @param maxRes maximum resolution
     */
    _setScales(maxRes) {
      const units       = GUI.getService('map').getMapUnits();
      const mapScale    = getScaleFromResolution(maxRes, units);
      const scales      = PRINT_SCALES.sort((a, b) => b.value - a.value);
      const below       = scales.filter(s => s.value < mapScale);           // all scales below mapScale
      const above       = scales.findLast(s => s.value >= mapScale);        // first scale above mapScale
      this.state.scales = (above ? [above] : []).concat(below);
      this.state.scales.forEach(s => this._resolutions[s.value] = getResolutionFromScale(s.value, units))
    },

    _initPrintConfig() {
      const view = GUI.getService('map').viewer.map.getView();
      if (!this._initialized) {
        this._setScales(view.getMaxResolution());
        this._initialized = true;
      }
      const resolution = view.getResolution();

      // set current scale
      Object
        .entries(this._resolutions)
        .find(([scala, res]) => {
          if (resolution <= res) {
            this.state.scale = scala;
            return true
          }
        });
    },


    reload() {
      this.state.print    = ApplicationState.project.state.print || [];
      const visible       = this.state.print.length > 0;
      const init          = this._initialized;
      this.state.template = visible ? this.state.print[0].name : this.state.template;
      if (visible && !init) {
        this.init();
      }
      if (visible) {
        this._initPrintConfig();
        const map = GUI.getService('map');
        map.on('changeviewaftercurrentproject', () => {
          this.state.scales = PRINT_SCALES;
          this._setScales(map.viewer.map.getView().getMaxResolution());
        });
      } else {
        this._clearPrint();
      }
    },

    initSelect2Field() {
      this.select2 = $('#print_atlas_autocomplete').select2({
        width: '100%',
        multiple: true,
        dropdownParent: $(this.$refs.print_atlas),
        minimumInputLength: 1,
        ajax: {
          delay: 500,
          transport: async (d, ok, ko) => {
            try {
              ok({
                results: (await getCatalogLayerById(this.state.atlas.qgs_layer_id).getFilterData({
                  suggest: `${this.state.atlas.field_name}|${d.data.q}`,
                  unique: this.state.atlas.field_name,
                })).map(v => ({ id: v, text: v }))
              });
            } catch(e) {
              console.warn(e);
              ko(e);
            }
          }
        },
        /**
         * @param { Object } params
         * @param params.term the term that is used for searching
         * @param { Object } data
         * @param data.text the text that is displayed for the data object
         */
        matcher: (params, data) => {
          const search = params.term ? params.term.toLowerCase() : params.term;
          if ('' === (search || '').toString().trim())                             { return data; }        // no search terms → get all of the data
          if (data.text.toLowerCase().includes(search) && undefined !== data.text) { return { ...data }; } // the searched term
          return null;                                                                                 // hide the term
        },
        language: {
          noResults:     () => t("sdk.search.no_results"),
          errorLoading:  () => t("sdk.search.error_loading"),
          searching:     () => t("sdk.search.searching"),
          inputTooShort: d => `${t("sdk.search.autocomplete.inputshort.pre")} ${d.minimum - d.input.length} ${t("sdk.search.autocomplete.inputshort.post")}`,
        },
      });
      this.select2.on('select2:select',   e => { this.atlas_values.push(e.params.data.id); });
      this.select2.on('select2:unselect', e => { this.atlas_values = this.atlas_values.filter(v => v != e.params.data.id); }); // NB: != instead of !== because sometime we need to compare "numbers" with "strings"
    },

  },

  watch: {

    async has_autocomplete(b) {
      if (!b) { return; }
      await this.$nextTick();
      this.initSelect2Field();
    },

    atlas_values: {
      immediate: true,
      async handler(vals) {
        if (this._skip_atlas_check || !this.state.atlas) {
          return;
        }
        if (this.has_autocomplete) {
          this.disabled = 0 === vals.length;
          return;
        }
        const validate = n => (n && Number.isInteger(1 * n) && 1 * n >= 0 && 1 * n < this.state.atlas.feature_count) || null;
        const values = new Set();
        const value = (vals ? vals[0] : '') || '';
        value
          .split(',')
          .filter(v => v)
          .forEach(value => {
            if (!value.includes('-') && null !== validate(value)) {
              values.add(value);
              return;
            }
            const _values = value.split('-');
            const range = _values.filter(v => validate(v) !== null);
            if (range.length === _values.length && range.reduce((bool, value, i) => bool && ((0 === i) || range[i-1] <= value), true)) {
              for (let i = 1; i < range.length; i++) {
                for (let j = range[i-1]; j < range[i]; j++ ) { values.add(j+''); }
              }
              values.add(range[range.length-1]);
            }
          });
        this._skip_atlas_check = true;
        this.atlas_values = Array.from(values);
        await this.$nextTick();
        this._skip_atlas_check = false;
        this.disabled = '' === value.trim();
      }
    },

    'state.url': async function(url) {
      if (!url) {
        return;
      }
      let timeout;

      try {

        await this.$nextTick();

        // add timeout
        timeout = setTimeout(() => {
          GUI.disableSideBar(false);
          this.state.downloading = false;
          GUI.showUserMessage({ type: 'alert', message: 'timeout' });
        }, TIMEOUT);

        const response = await fetch(url);

        if (!response.ok) {
          throw response.statusText;
        }
      } catch (e) {
        console.warn(e);
        GUI.notify.error(e || t("info.server_error"));
        GUI.closeContent();
      } finally {
        clearTimeout(timeout);
        GUI.disableSideBar(false);
        this.state.downloading = false;
      }

    }

  },

  /**
   * @since 3.10.2
   */
  async mounted() {
    await this.$nextTick();
    // when default print template is "atlas" → initialize select2
    if (this.state.atlas) {
      this.initSelect2Field();
    }
  }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"treeview-menu",attrs:{"id":"print"}},[_c('li',[(_vm.state.print.length)?_c('form',{staticClass:"g3w-search-form form-horizonal",staticStyle:{"border-radius":"0 0 3px 3px","padding":"10px"}},[_c('bar-loader',{attrs:{"loading":_vm.state.loading}}),_vm._v(" "),_c('fieldset',{staticStyle:{"border":"1px solid","padding":"4.9px 8.75px 8.75px 10.5px","border-radius":"3px","background-color":"hsl(from var(--bgcolor) h s calc(l + 8))","color":"rgb(255, 255, 255)","user-select":"none"}},[_c('legend',{staticStyle:{"width":"15px","height":"15px","border":"1px solid","border-radius":"50%","background-color":"rgb(34, 45, 50)","font-weight":"bold","color":"rgb(255, 255, 255)","font-size":"0.7em","display":"flex","justify-content":"center","margin":"0px -14px","user-select":"none"}},[_vm._v("i")]),_vm._v(" "),_c('details',[_c('summary',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:('show_more'),expression:"'show_more'",arg:"right",modifiers:{"create":true}}],staticStyle:{"cursor":"pointer","display":"flex","justify-content":"space-between","align-items":"center","width":"100%"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.help'),expression:"'sdk.print.help'"}],staticStyle:{"text-overflow":"ellipsis","overflow":"hidden"}}),_vm._v(" "),_c('i',{staticClass:"far fa-eye"})]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"10px 0","border-style":"dotted"}}),_vm._v(" "),_c('div',{directives:[{name:"t-html",rawName:"v-t-html",value:('sdk.print.help_details'),expression:"'sdk.print.help_details'"}],staticStyle:{"white-space":"wrap","line-height":"25px"}})])]),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.template'),expression:"'sdk.print.template'"}],attrs:{"for":"templates"}}),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('state.template'),expression:"'state.template'"}],staticClass:"form-control",style:({ marginBottom: this.state.atlas && '10px' }),attrs:{"id":"templates","select2_value":_vm.state.template},on:{"change":_vm.changeTemplate}},_vm._l((_vm.state.print),function(print){return _c('option',{domProps:{"value":print.name}},[_vm._v(_vm._s(print.name))])}),0),_vm._v(" "),(!_vm.state.atlas)?[_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.scale'),expression:"'sdk.print.scale'"}],attrs:{"for":"scale"}}),_vm._v(" "),_c('select',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.has_maps),expression:"!has_maps"},{name:"select2",rawName:"v-select2",value:('state.scale'),expression:"'state.scale'"}],ref:"scales",staticClass:"form-control",attrs:{"id":"scale","select2_value":_vm.state.scale,"createTag":true},on:{"change":_vm.changeScale}},_vm._l((_vm.state.scales),function(scale){return _c('option',{domProps:{"value":scale.value}},[_vm._v(_vm._s(scale.label))])}),0),_vm._v(" "),_c('label',{attrs:{"for":"dpi"}},[_vm._v("dpi")]),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('state.dpi'),expression:"'state.dpi'"}],ref:"dpi",staticClass:"form-control",attrs:{"id":"dpi","select2_value":_vm.state.dpi,"createTag":true},on:{"change":_vm.changeDpi}},_vm._l((_vm.state.dpis),function(dpi){return _c('option',[_vm._v(_vm._s(dpi))])}),0),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.rotation'),expression:"'sdk.print.rotation'"}],attrs:{"for":"rotation"}}),_vm._v(" "),_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.has_maps),expression:"!has_maps"},{name:"model",rawName:"v-model",value:(_vm.state.rotation),expression:"state.rotation"}],staticClass:"form-control",attrs:{"id":"rotation","min":"-360","max":"360","type":"number"},domProps:{"value":(_vm.state.rotation)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "rotation", $event.target.value)},_vm.changeRotation]}}),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.format'),expression:"'sdk.print.format'"}],attrs:{"for":"format"}}),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('state.format'),expression:"'state.format'"}],staticClass:"form-control",attrs:{"id":"format","select2_value":_vm.state.format}},_vm._l((_vm.state.formats),function(format){return _c('option',{domProps:{"value":format.value}},[_vm._v(_vm._s(format.label))])}),0)]:_vm._e(),_vm._v(" "),(_vm.state.atlas)?_c('div',{ref:"print_atlas",staticClass:"form-group",staticStyle:{"width":"100%"}},[(_vm.has_autocomplete)?[_c('label',{attrs:{"for":"print_atlas_autocomplete"}},[_c('span',[_vm._v(_vm._s(_vm.state.atlas.field_name))])]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"print_atlas_autocomplete","name":_vm.state.atlas.field_name}})]:[_c('label',[_c('span',[_vm._v("fids [max: "+_vm._s(_vm.state.atlas.feature_count - 1)+"]")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.atlas_values),expression:"atlas_values"}],staticClass:"form-control",domProps:{"value":(_vm.atlas_values)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.atlas_values=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"fid-print-atals-instruction"}},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.fids_instruction'),expression:"'sdk.print.fids_instruction'"}],attrs:{"id":"fids_intruction"}}),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.fids_example'),expression:"'sdk.print.fids_example'"}],attrs:{"id":"fids_examples_values"}})])]],2):_vm._e(),_vm._v(" "),(_vm.state.labels && _vm.state.labels.length > 0)?_c('div',{staticClass:"print-labels-content"},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('sdk.print.labels'),expression:"'sdk.print.labels'"}],staticClass:"skin-color"}),_vm._v(" "),_c('div',{staticClass:"labels-input-content"},_vm._l((_vm.state.labels),function(label){return _c('span',{key:label.id},[_c('label',{attrs:{"for":("g3w_label_id_input_" + (label.id))}},[_vm._v(" "+_vm._s(label.id))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(label.text),expression:"label.text"}],staticClass:"form-control",attrs:{"id":("g3w_label_id_input_" + (label.id))},domProps:{"value":(label.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(label, "text", $event.target.value)}}})])}),0)]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.disabled),expression:"disabled"},{name:"download",rawName:"v-download"},{name:"t",rawName:"v-t",value:('create_print'),expression:"'create_print'"}],staticClass:"sidebar-button-run btn",attrs:{"id":"printbutton"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.print.apply(null, arguments)}}})],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding":"1em","text-align":"center"}},[_c('b',[_c('a',{attrs:{"href":("https://docs.qgis.org/3.34/" + _vm.lang + "/docs/training_manual/map_composer/map_composer.html"),"target":"_blank","title":"QGIS Docs"}},[_c('i',{class:_vm.$fa('external-link')}),_vm._v(" Edit in QGIS\n      ")])])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-75319110_0", { source: "#print .select2-container--open{width:100%}#print .select2-container--open input.select2-search__field{color:#555;width:100%}#print.treeview-menu .select2.select2-container{display:block}", map: undefined, media: undefined })
,inject("data-v-75319110_1", { source: ".print-labels-content[data-v-75319110]{margin:15px 0;color:#fff}.print-labels-content>span.skin-color[data-v-75319110]{font-size:1.1em;display:block;border-bottom:2px solid #fff;margin-bottom:5px}.print-labels-content>.labels-input-content[data-v-75319110]{max-height:120px;overflow-y:auto}label[data-v-75319110]{color:#fff}#printbutton[data-v-75319110]{width:100%;font-weight:700;background-color:var(--skin-color);margin:15px 0}#fid-print-atals-instruction[data-v-75319110]{margin-top:5px;color:#fff}#fids_intruction[data-v-75319110]{white-space:pre-line}#fids_examples_values[data-v-75319110]{margin-top:3px;font-weight:700}.g3w-search-form>label[data-v-75319110]:not(:nth-child(1)){margin-top:15px}details[open] .fa-eye[data-v-75319110]{display:none}details[open] summary>span[data-v-75319110]{overflow:visible!important}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-75319110"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Print.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__